import React from 'react'
import { SessionProvider } from '@crunchyroll/cr-static-shared-components'

import { AdProvider } from '@contexts/AdContext'
import { DateProvider } from '@contexts/DateContext'
import { ResetProvider } from '@contexts/ResetContext'
import { VoteProvider } from '@contexts/VoteContext'
import { VoteApiProvider } from '@contexts/VoteApiContext'
import DatadogWrapper from '@components/datadog/DatadogWrapper'

const wrapRoot = ({ element }) => (
  <SessionProvider>
    <DateProvider>
      <ResetProvider>
        <VoteApiProvider>
          <VoteProvider>
            <AdProvider>
              <DatadogWrapper>{element}</DatadogWrapper>
            </AdProvider>
          </VoteProvider>
        </VoteApiProvider>
      </ResetProvider>
    </DateProvider>
  </SessionProvider>
)

export default wrapRoot
